var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrap"},_vm._l((_vm.allUsers),function(user){return _c('userPreview',{key:user.id,attrs:{"user":user}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }